import axios from "axios";
import { Button, Checkbox, FloppyDiskIcon, Pane, Select, SelectField, Text } from "evergreen-ui";
import { mua } from "../../config/api";

import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";

function FormRegistNurse() {
  let headers = new Headers({
    "Content-Type": "application/x-www-form-urlencoded",
    Authorization: `Basic ${localStorage.getItem("token")}`,
  });
  const [DataFac, setDataFac] = useState([]);
  const [DataMaj, setDataMaj] = useState([]);
  const [DataType, setDataType] = useState([]);
  const [Check, setCheck] = useState(false);
  useEffect(() => {
    axios
      .get(mua + "/admissionnew2022/showtype/1")
      .then((res) => {
        // console.log(res.data.data.data)
        const datarare = res.data.data.data;
        const data = datarare.map((i) => ({
          value: i.type_std_id,
          label: i.type_std_name,
        }));
        setDataType(data);
      });
  }, []);
  const ChangeTyp = (val) => {
    let bodydata = {
      typestudent: localStorage.getItem("typestudent"),
      level: localStorage.getItem("level"),
      plan: localStorage.getItem("plan"),
      vga: localStorage.getItem("vga"),
      typestd: val,
      level_saka: "1",
      faculty: "",
      faculty2: "",
      faculty3: "",
      courseyear: "1",
    };
    setInput((values) => ({ ...values, faculty2: "" }));
    setInput((values) => ({ ...values, typestd2: val }));
    setInput((values) => ({ ...values, majorid2: "" }));
    axios
      .post(mua + "/admissionnew2022/showfaculty", bodydata, {
        headers: headers,
      })
      .then((res) => {
        // console.log(res.data.data.data);
        const datafac = [];
        const datarare = res.data.data.data;
        datarare.forEach((u) => {
          if (u.id_fac !== "2")
            datafac.push({
              value: u.id_fac,
              label: u.faculty_name,
            });
        });
        setDataFac(datafac);
      });
  };

  const FacChange = (val) => {
    let bodydata = {
      typestudent: localStorage.getItem("typestudent"),
      level: localStorage.getItem("level"),
      plan: localStorage.getItem("plan"),
      vga: localStorage.getItem("vga"),
      typestd: Input.typestd2,
      level_saka: "1",
      faculty: val,
      faculty2: "",
      faculty3: "",
      saka1: "",
      saka2: "",
      saka3: "",
      courseyear: "1",
    };
    setInput((values) => ({ ...values, majorid2: "" }));
    if (val === "#") {
      setInput((values) => ({ ...values, faculty2: "" }));
    } else {
      setInput((values) => ({ ...values, faculty2: val }));
    }
    axios
      .post(mua + "/admissionnew2022/showsaka", bodydata, {
        headers: headers,
      })
      .then((res) => {
        console.log(res.data.data.data);
        const datarare = res.data.data.data;
        const datamaj = [];
        const data = datarare.filter(
          ({ LEVEL_NAME, MAJOR_ID }) =>
            LEVEL_NAME !== "ครุศาสตรบัณฑิต" && MAJOR_ID !== "1110" && MAJOR_ID !== "1304"&& MAJOR_ID !== "1310"
        );
        data.map((i, n) => {
          i.MAJOR_ID !== "1106" &&
            datamaj.push({
              value: i.MAJOR_ID,
              label: i.MAJOR_NAME + "( " + i.LEVEL_OPEN_NAME + " )",
            });
        });
        setDataMaj(datamaj);
      });
  };
  const [Input, setInput] = useState({
    faculty2: "",
    majorid2: "",
  });
  const ChangeMaj = (val) => {
    if (val !== "#") {
      setInput((values) => ({ ...values, majorid2: val, typestd2: "1" }));
    } else {
      setInput((values) => ({ ...values, majorid2: "", typestd2: "1" }));
    }
  };

  return (
    <div className="pt-3 container-md">
      <Pane paddingLeft={10} display="flex" flexDirection={"column"}>
        <Text color="#212529" fontFamily="" fontSize={20} fontWeight={700}>
          สมัครเรียนปริญญาตรีภาคปกติ (จันทร์-ศุกร์) มหาวิทยาลัยราชภัฏกำแพงเพชร
        </Text>
        <Text
          paddingTop={20}
          paddingLeft={20}
          color="#4a4e69"
          fontFamily=""
          fontSize={16}
          fontWeight={500}
        >
          สามารถเลือกสาขาลำดับ 2 รองจากพยาบาลศาสตร์ได้
        </Text>
        <Checkbox
          label="ต้องการเลือกสาขาที่ 2 "
          checked={Check}
          onChange={() => {
            setCheck(!Check);
          }}
        />
        <Checkbox
          label="ไม่ต้องการเลือกสาขาที่ 2 "
          checked={!Check}
          onChange={() => {
            setCheck(!Check);
          }}
        />
        {Check ? (
          <>
            <Pane className="py-3">
              <SelectField
                onChange={(v) => {
                  ChangeTyp(v.target.value);
                }}
                label="เลือกประเภทนักศึกษา"
              >
                <option value={"#"}>==เลือกประเภทนักศึกษา==</option>
                {Array.isArray(DataType) &&
                  DataType.map((i, n) => <option value={i.value}>{i.label}</option>)}
              </SelectField>
              <SelectField
                onChange={(v) => {
                  FacChange(v.target.value);
                }}
                label="เลือกคณะ"
              >
                <option value={"#"}>==เลือกคณะ==</option>
                {Array.isArray(DataFac) &&
                  DataFac.map((i, n) => <option value={i.value}>{i.label}</option>)}
              </SelectField>
              <SelectField
                label="เลือกสาขา"
                onChange={(v) => {
                  ChangeMaj(v.target.value);
                }}
              >
                <option value={"#"}>==เลือกสาขา==</option>
                {Array.isArray(DataMaj) &&
                  DataMaj.map((i, n) => <option value={i.value}>{i.label}</option>)}
              </SelectField>
            </Pane>
          </>
        ) : (
          <></>
        )}
        <Pane>
          <Button
            disabled={
              Check ? (Input.faculty2 !== "" && Input.majorid2 !== "" ? false : true) : false
            }
            iconBefore={<FloppyDiskIcon />}
            appearance="primary"
            intent="success"
            onClick={() => {
              localStorage.setItem("faculty2", Input.faculty2);
              localStorage.setItem("majorid2", Input.majorid2);
              localStorage.setItem("typestd2", Input.typestd2);
              window.location.href = `${process.env.REACT_APP_BASENAME || ""}/Formprofile`;
            }}
          >
            บันทึก
          </Button>
        </Pane>
      </Pane>
    </div>
  );
}

export default FormRegistNurse;


